import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
// Initialize Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'crema-react.firebaseapp.com',
  databaseURL: 'https://crema-react.firebaseio.com',
  projectId: 'crema-react',
  storageBucket: 'crema-react.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
// This app only uses JWT auth in production; Firebase sign-in is unused
// legacy template scaffolding. Guard its init so a missing/invalid
// REACT_APP_FIREBASE_* config (e.g. after removing hardcoded demo keys)
// can't throw at module-load time and take down the whole app before
// React even mounts -- this crashed the entire site on 2026-09-03.
let auth!: firebase.auth.Auth;
let googleAuthProvider!: firebase.auth.GoogleAuthProvider;
let githubAuthProvider!: firebase.auth.GithubAuthProvider;
let facebookAuthProvider!: firebase.auth.FacebookAuthProvider;
let twitterAuthProvider!: firebase.auth.TwitterAuthProvider;

try {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  auth = firebase.auth();
  googleAuthProvider = new firebase.auth.GoogleAuthProvider();
  githubAuthProvider = new firebase.auth.GithubAuthProvider();
  facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
  twitterAuthProvider = new firebase.auth.TwitterAuthProvider();
} catch (err) {
  console.error('Firebase auth is not configured; Firebase sign-in is unavailable.', err);
}

export {
  auth,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
};
